// src/components/Users.js

import { Breadcrumb, Empty } from "antd";
import { Input } from "antd";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddUserButton from "./AddUserButton";
import UserCard from "./UserCard";
import Grid from "@material-ui/core/Grid";
import { getAllUsers } from "../../../redux/User/actions";

const { Search } = Input;

export const Users = () => {
  const dispatch = useDispatch();
  const users = useSelector((state) => state.Users?.data);
  const [usersearch, setusersearch] = useState([]);
  const [search_Mode, setsearch_Mode] = useState(false);
  const [loading, setLoading] = useState(false);
  const hasFetched = useRef(false); // Ref to control fetching

  useEffect(() => {
    if (!hasFetched.current) {
      setLoading(true);
      dispatch(getAllUsers()).finally(() => {
        setLoading(false);
        hasFetched.current = true; // Prevent further fetches until the component mounts
      });
    }
  }, [dispatch]);

  const userSearch_Fun = (value) => {
    if (value.length > 0) {
      setsearch_Mode(true);
      const users2 = users.filter((el) => el.username.includes(value));
      setusersearch(users2);
    } else {
      setsearch_Mode(false);
      setusersearch([]);
    }
  };

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0px" }}>
        <Breadcrumb.Item>Users</Breadcrumb.Item>
        <div style={{ float: "right", marginTop: 20 }}>
          <Grid container>
            <Grid item>
              <Grid container justify="center"></Grid>
              <Search
                placeholder="Search"
                onChange={(e) => {
                  if (e.target.value.length === 0) setsearch_Mode(false);
                }}
                style={{ minWidth: 150, maxWidth: 220 }}
                enterButton
                onSearch={userSearch_Fun}
              />
              <AddUserButton></AddUserButton>
            </Grid>
          </Grid>
        </div>
      </Breadcrumb>
      <br />
      <br />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container justify="center" spacing={2}>
            {search_Mode ? (
              usersearch.length === 0 ? (
                <Empty></Empty>
              ) : (
                usersearch.map((item, index) => {
                  return (
                    <Grid key={index} item>
                      <UserCard item={item}></UserCard>
                    </Grid>
                  );
                })
              )
            ) : (
              
              users.map((item, index) => {
                return (
                  <Grid key={index} item>
                    <UserCard item={item}></UserCard>
                  </Grid>
                );
              })
            )}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Users;
